import { SLOTS_APIS } from "@/api_framework/api_config";
import { IBookingPurchaseOptionsResponse, IBookingPurchaseOptionsResponseData } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import {
  setBookingCartPreviewData,
  setPurchaseOptionsData,
  setSelectedPurchaseAddOnIds,
  setSelectedPurchaseMembershipId,
  setSelectedPurchaseServiceId,
} from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useBookingPurchaseOptionsAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [isPurchaseOptionsInProgress, setIsPurchaseOptionsInProgress] = useState(false);

  const execute = useCallback(
    async (params: { sub_service_id: string; clinic_id: string; user_id: string,pet_id:string }) => {
      if (!params?.sub_service_id || !params?.clinic_id || !params?.user_id) {
        dispatch(setPurchaseOptionsData({ data: null }));
        dispatch(setBookingCartPreviewData({ data: null }));
        return null;
      }

      setIsPurchaseOptionsInProgress(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(SLOTS_APIS?.PURCHASE_OPTIONS?.baseURL ?? "", {
            params,
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBookingPurchaseOptionsResponse>) => {
            if (res.data.status && res.data.data) {
              const optionsData: IBookingPurchaseOptionsResponseData = res.data.data;
              dispatch(setPurchaseOptionsData({ data: optionsData }));
              dispatch(setBookingCartPreviewData({ data: null }));
              dispatch(setSelectedPurchaseServiceId(optionsData?.services?.[0]?.id ?? null));
              dispatch(setSelectedPurchaseAddOnIds({ data: [] }));
              dispatch(setSelectedPurchaseMembershipId(null));
              return optionsData;
            }

            dispatch(setPurchaseOptionsData({ data: null }));
            dispatch(setBookingCartPreviewData({ data: null }));
            return null;
          })
          .catch((e: AxiosError) => {
            if (e.config?.["curlCommand"]) {
              sendCurl(e.config["curlCommand"]);
            }
            dispatch(setPurchaseOptionsData({ data: null }));
            dispatch(setBookingCartPreviewData({ data: null }));
            return null;
          });

        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        dispatch(setPurchaseOptionsData({ data: null }));
        dispatch(setBookingCartPreviewData({ data: null }));
        return null;
      } finally {
        setIsPurchaseOptionsInProgress(false);
      }
    },
    [configuration, dispatch, sendCurl],
  );

  return {
    execute,
    isPurchaseOptionsInProgress,
  };
};
